import type { TravelPeriod } from "@/libs/server/goApiServer/promotion/promotionServiceInterface/getPromotionDetailInterface";

export interface RequestFlightOfferInterface {
  flightType?: string;

  limit: number;

  page: number;

  airlineSlug?: string;

  airportCodeDeparture?: string;

  airportCodeArrival?: string;
}
export class ResponseFlightOffer {
  status: boolean;

  total: number;

  totalPages: number;

  couponCode: string[] | string;

  promotionTravelPeriod: TravelPeriod | null;

  flightDeal: {
    flightOfferId: string;
    airlineSlug: string;
    airlineName: string;
    flightType: string;
    ticketingPeriod: string;
    travelPeriod: string;
    fromAirportCode: string;
    toAirportCode: string;
    price: number;
    flightName: string;
    cityName: string;
    citySlug: string;
    photoPath: string;
    flightOfferSlug: string;
    airportCityTo: string;
    airportCityFrom: string;
    airlineLogo: string;
    currency: string;
    dateSearchDeparture: string;
    dateSearchReturn: string;
    ticketingFromDate?: string;
    ticketingToDate?: string;
    travelFromDate?: string;
    travelToDate?: string;
    perks?: {
      freebies: string[];
      privileges: string[];
    };
    isRecommended: boolean;
    isSpecialDeal: boolean;
  }[];

  constructor(data: any) {
    this.status = data.status || false;
    this.total = data.total || 0;
    this.totalPages = data.totalPages || 0;
    this.couponCode = "";
    this.promotionTravelPeriod = null;

    this.flightDeal = (data.flightDeal || []).map((item: any) => ({
      flightOfferId: item.flightOfferId || "",
      flightOfferSlug: item.flightOfferSlug || "",
      airlineSlug: item.airlineSlug || "",
      airlineName: item.airlineName || "",
      flightType: item.flightType || "",
      ticketingPeriod: item.ticketingPeriod || "",
      travelPeriod: item.travelPeriod || "",
      fromAirportCode: item.fromAirportCode || "",
      toAirportCode: item.toAirportCode || "",
      price: item.price || 0,
      flightName: item.flightName || "",
      cityName: item.cityName || "",
      citySlug: item.citySlug || "",
      photoPath: item.photoPath || "",
      airportCityTo: item.airportCityTo || "",
      airportCityFrom: item.airportCityFrom || "",
      airlineLogo: item.airlineLogo || "",
      currency: item.currency || "THB",
      dateSearchDeparture: item.dateSearchDeparture || "",
      dateSearchReturn: item.dateSearchReturn || null,
      ticketingFromDate: item.ticketingFromDate || "",
      ticketingToDate: item.ticketingToDate || "",
      travelFromDate: item.travelFromDate || "",
      travelToDate: item.travelToDate || "",
      perks: item?.perks || null,
      isRecommended: item?.isRecommended || false,
      isSpecialDeal: item?.isSpecialDeal || false,
    }));
  }
}
export interface FlightDealInterface {
  coupon?: string[] | string;
  promotionTravelPeriod?: TravelPeriod | null;
  flightDeal: {
    flightOfferId: string;
    airlineSlug: string;
    airlineName: string;
    flightType: string;
    ticketingPeriod: string;
    travelPeriod: string;
    fromAirportCode: string;
    fromAirportCityName?: string;
    toAirportCode: string;
    toAirportCityName?: string;
    price: number;
    flightName?: string;
    cityName?: string;
    photoPath: string;
    airportCityTo?: string;
    airportCityFrom?: string;
    airlineLogo?: string;
    cityFromName?: string;
    cityToName?: string;
    cityFromSlug?: string;
    cityToSlug?: string;
    flightDescription?: string;
    intro?: string;
    slug?: string;
    currency?: string;
    url?: string;
    dateSearchDeparture?: string;
    dateSearchReturn?: string;
    ticketingFromDate?: string;
    ticketingToDate?: string;
    travelFromDate?: string;
    travelToDate?: string;
    perks?: {
      freebies: string[];
      privileges: string[];
    };
    isRecommended?: boolean;
    isSpecialDeal?: boolean;
  };

  isPromotionLanding?: boolean;

  isAirline?: boolean;
  isMultiple?: boolean;
}
